export const SET_USER = 'user/set'
export const RESET_USER = 'user/reset'
